export default {
  socialNetworks: 'social networks',
  sentEmails: 'sent emails',
  peoplePerDay: 'People per day',
  peoplePerMonth: 'People per month',
  statsPerApp: 'applications statistics',
  search: 'Search',
  name: 'Name',
  people: 'Contacts',
  person: 'Person',
  sentMessages: 'sent messages',
  messagesParts: 'messages parts',
  applicationsPerPage: 'Applications per page',
  cellphoneRecords: 'cellphone records',
  totalRecords: 'Total records',
  noName: 'Nameless',
  noJourneyId: 'Without ID',
  noAppsToShow: 'There aren´t apps to show',
  manualPayment: 'Manual payment',
  manualCollection: 'Manual collection',
  noDataYet: 'There aren´t data at the moment'
}
